import { apiRequest } from "@shared/services/api/apiRequest";

export async function generatePresignedUrl(file, metadata = {}) {
  const payload = {
    file_name: file.name,
    file_type: file.type,
    file_size: file.size,
    upload_type: metadata.file_type || "document",
    organization_id: metadata.organization_id,
  };

  const response = await apiRequest(
    "/api/generate-presigned-url/",
    "POST",
    payload,
    true
  );
  return response;
}
